// eslint-disable-next-line @typescript-eslint/no-unused-vars
import '../styles/global.scss';
import '../styles/responsive.scss';
import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrivateRoute } from './components/private-router/PrivateRouter';
import LayoutPortal from './layouts/layout-portal/LayoutPortal';
import ModalManageFile from './components/modal-manage-upload-file/ModalManageFile';
const LoginPageDemoHub = React.lazy(() => import('./pages/login-page-demo-hub/LoginPageDemoHub'));
const ChatAssitsantPage = React.lazy(() => import('./pages/chat-page-assistant/ChatPage'));
const NotFoundPage = React.lazy(() => import('./pages/not-found-page/not-found-page'));
const SynthensisComponent = React.lazy(() => import('./pages/page-synthesisdata/synthesis'));

export function App() {
  const location = useLocation();
  const urlParams = new URLSearchParams(window.location.search);
  const language = urlParams.get('language');
  const { i18n } = useTranslation();
  
  useEffect(() => { 
    if (language && (language === 'en' || language === 'vi' || language === 'ja')) {
      i18n.changeLanguage(language);
    }
  }, []);

  return (
     <div className="app">
      <Routes location={location}>
        {/* Route có LayoutPortal */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <LayoutPortal />
            </PrivateRoute>
          }
        >
          {/* Component cụ thể bên trong layout */}
          <Route index element={<SynthensisComponent />} />
        </Route>

        {/* Các route khác nếu cần */}
        <Route path="/login" element={<LoginPageDemoHub />} />
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
